// extracted by mini-css-extract-plugin
export default {"OrganizationDefaults":"OrganizationDefaults_OrganizationDefaults__0i5Tt","cardCol":"OrganizationDefaults_cardCol__4ZVlm","table":"OrganizationDefaults_table__6DIGS"};